import { useSyncExternalStore } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

// Module-level matchMedia listeners shared across all hook instances
const MOBILE_QUERY = '(max-width: 639px)';
const DESKTOP_QUERY = '(min-width: 1024px)';

let mobileMatch: MediaQueryList | null = null;
let desktopMatch: MediaQueryList | null = null;

function getMediaQueryLists() {
  if (typeof window === 'undefined') return;
  if (!mobileMatch) mobileMatch = window.matchMedia(MOBILE_QUERY);
  if (!desktopMatch) desktopMatch = window.matchMedia(DESKTOP_QUERY);
}

function getSnapshot(): DeviceType {
  getMediaQueryLists();
  if (desktopMatch?.matches) return 'desktop';
  if (mobileMatch?.matches) return 'mobile';
  return 'tablet';
}

function getServerSnapshot(): DeviceType {
  return 'mobile'; // SSR fallback
}

function subscribe(callback: () => void): () => void {
  getMediaQueryLists();
  mobileMatch?.addEventListener('change', callback);
  desktopMatch?.addEventListener('change', callback);
  return () => {
    mobileMatch?.removeEventListener('change', callback);
    desktopMatch?.removeEventListener('change', callback);
  };
}

export function useDeviceType(): DeviceType {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function useIsMobile(): boolean {
  return useDeviceType() === 'mobile';
}

export function useIsDesktop(): boolean {
  return useDeviceType() === 'desktop';
}
